<template>
    <div>

        <on-top-container>
            <img slot="middleRight"
                 :src="ass_img_xLetter_b"
                 class="TQ_width_12px TQ_verticalAlignMiddle TQ_padding_8px"
                 :class="deleteImgClass"
                 v-if="currentText"
                 @click="cleanText()" />

            <input  slot="body"
                    @click="m_clickInput_f"
                    autocomplete="off"
                    class="TQ_verticalAlignMiddle"
                    :class="inputClass"
                    :placeholder="inputPlaceholder"
                    v-model="currentText"
                    @input="updateText(currentText)"/>
        </on-top-container>

    </div>
</template>

<script>
    import OnTopContainer from "../basic/TqOnTopContainer";
    import {ass_img_xLetter_b} from "../../assets/scripts/Ass_Files";
    import {enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import {store_getStateValue_vo, store_var} from "../../store";
    import {webAppManager_clickInput_f} from "../../scripts/S_WebAppMediator";
    export default {
        name: "TqInputFastDelete",
        components: {OnTopContainer},
        props:{
            initText : {
                type: String,
                default: ""
            },
            inputClass:{
                type: String,
                default: ""
            },
            inputPlaceholder:{
                type: String,
                default: ""
            },
            deleteImgClass:{
                type: String,
                default: ""
            },
            updateText: {
                require: true,
                type: Function
            }
        },
        data(){
            return {
                currentText: null,
                ass_img_xLetter_b : ass_img_xLetter_b,
                store_system_windowSizeType_e : store_getStateValue_vo(store_var.system_windowSizeType_e).val,
                enum_screenSizesOptions_n : enum_screenSizesOptions_n,
            }
        },
        mounted(){
            this.currentText = this.initText
        },
        methods:{
            cleanText(){
                this.currentText = ''
                this.updateText(this.currentText)
            },
            m_clickInput_f(e){

                webAppManager_clickInput_f(e)

            }
        },
        deactivated(){
            this.currentText = ""
        },

    }
</script>

<style scoped>


</style>